import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ValidatedCollapseCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/linkedin-data';
import { LinkedInLogo24 } from '@bingads-webui-campaign-react/linkedin-shared-components';
import { entityIs } from '@bingads-webui-campaign-react/form-error';

import { TargetingAudiences } from '../components/targeting-audiences';
import { AudiencesSkeleton } from '../components/skeletons';
import { withValidationWrapper } from '../utils';

const withUnvalidatedControlErrorsWrapper = _.partial(withUnvalidatedControlErrors, _, { filter: entityIs(ERROR_ENTITY.AudienceTargeting) });

const ServerValidatedTargetingAudiences = _.compose(
  withControlErrorHandling,
  withUnvalidatedControlErrorsWrapper,
  withValidationWrapper
)(TargetingAudiences);

export const CollapsibleAudiences = ({ isLoading, ...cardProps }) => {
  const i18n = useContext(I18nContext);

  return (
    <ValidatedCollapseCard {...cardProps}>
      <FormCardBasicHeader
        title={i18n.getString(_TL_('LinkedIn audience'))}
        contentBefore={<LinkedInLogo24 />}
      />
      <FormCardBody>
        {!isLoading ? (
          <ServerValidatedTargetingAudiences
            validationProps={{ field: 'audiences' }}
          />
        ) : <AudiencesSkeleton />}
      </FormCardBody>
    </ValidatedCollapseCard>
  );
};

CollapsibleAudiences.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};
